module.exports = __webpack_public_path__ + "static/media/RIESGOS_BIOLOGICOS.bc2587cf.jpg";